export enum AccessLevel {
    ServiceProvider = 1,
    Operator = 2,
    CompanyGroup = 3,
    Company = 4,
    Contractor = 5
}
